import React, { useState, useEffect } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';
import { useStateValue } from '../../functions/StateProvider';
import { firebaseApp, auth, provider } from '../../firebase';
import { actionTypes } from '../../functions/reducer';
import PersonalAreaModal from '../Modal/PersonalAreaModal';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
const Menu = () => {
  return (
    <>
      <p>
        <a href="#home">Home</a>
      </p>
      <p>
        <a href="#features">Tools and Skills</a>
      </p>
      <p>
        <a href="#projects">Projects</a>
      </p>
      <p>
        <a href="#about">About Me</a>
      </p>
    </>
  );
};

const Navbar = () => {
  //dispatch actually uses the useStateValue() hook
  //value={useReducer(reducer, initialState)}
  const [user, dispatch] = useStateValue();
  const [toggleMenu, setToggleMenu] = useState(false);

  //modal state
  const [show, setShow] = useState(false);

  const handleLogin = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        dispatch({ type: actionTypes.SET_USER, user: result.user });
      })
      .catch((err) => err);
  };

  //modal handlers
  const handleClose = () => setShow(false);
  const handleModalShow = () => {
    setShow(true);
  };

  return (
    <div className="gpt3__navbar">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <h3>Alex Kreizelman</h3>
        </div>
        <div className="gpt3__navbar-links_container">
          <Menu />
        </div>
      </div>
      <div className="gpt3__navbar-sign">
        {user.user ? (
          <p onClick={handleModalShow}>Personal Area</p>
        ) : (
          <p onClick={handleLogin}>Sign in</p>
        )}
      </div>

      <div className="gpt3__navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
      </div>

      {toggleMenu && (
        <div className="gpt3__navbar-menu_container scale-up-center">
          <div className="gpt3__navbar-menu_container-links">
            <Menu />
            <div className="gpt3__navbar-menu_container-links-sign">
              {}
              {user.user ? (
                <p>Hey {user.user.email}</p>
              ) : (
                <p onClick={handleLogin}>Sign in</p>
              )}
            </div>
          </div>
        </div>
      )}
      <PersonalAreaModal show={show} onHide={handleClose}></PersonalAreaModal>
    </div>
  );
};

export default Navbar;
